import * as React from 'react';

import PaginatedEntityTable from 'components/common/PaginatedEntityTable';
import QueryHelper from 'components/common/QueryHelper';
import { Col } from 'common/components';
import { useFetchEventProcedureSteps } from 'security-app/hooks/useEventProceduresAPI';
import type { EventProcedureStepAPIType } from 'security-app/hooks/api/eventProceduresAPI.types';
import type { SearchParams } from 'stores/PaginationTypes';
import type { PaginatedResponse } from 'components/common/PaginatedEntityTable/useFetchEntities';
import { CurrentUserStore } from 'stores/users/CurrentUserStore';

import { useColumnRenderers } from './column-renderers';
import { listElements, deserializeEventProceduresSteps, entityActionRender } from './constants';

import EventProcedureTabs from '../EventProcedureTabs';

type Props = {
  useCoreRoutes?: boolean;
};

function EventProcedureLilList({ useCoreRoutes = false }: Props) {
  const { columnRenderers } = useColumnRenderers();
  const { eventProcedureStepsEntitiesKeyFn, searchEventProcedureSteps } = useFetchEventProcedureSteps(
    deserializeEventProceduresSteps,
  );
  const fetchEntities = (options: SearchParams): Promise<PaginatedResponse<EventProcedureStepAPIType>> => {
    CurrentUserStore.update(CurrentUserStore.getInitialState().currentUser.username);

    return searchEventProcedureSteps(options);
  };

  return (
    <Col $align="center">
      <PaginatedEntityTable<EventProcedureStepAPIType>
        humanName="Event Procedure Steps"
        columnsOrder={listElements.columnOrder}
        queryHelpComponent={<QueryHelper entityName="Event Procedure Step" />}
        tableLayout={listElements.defaultLayout}
        fetchEntities={fetchEntities}
        keyFn={eventProcedureStepsEntitiesKeyFn}
        entityActions={entityActionRender}
        entityAttributesAreCamelCase={false}
        columnRenderers={columnRenderers}
        topRightCol={<EventProcedureTabs viewType="steps" useCoreRoutes={useCoreRoutes} />}
      />
    </Col>
  );
}

export default EventProcedureLilList;
